import React from 'react';

import {mediaService} from '../services/Media.service';

import {UserMediaContext} from './userMedia.context';

export const UserMediaContextProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    return (
        <UserMediaContext.Provider value={mediaService}>
            {children}
        </UserMediaContext.Provider>
    );
};
